<template>
  <!-- 原开放题 4 7 8-->
  <div>
    <p v-if="rowData?.questionDetails?.issue?.fillText">
      {{ rowData.questionDetails.issue.fillText }}
    </p>
    <p v-show="isError" style="color: rgb(247, 73, 69)">{{ errorText }}</p>   
    <el-input
      style="display: block"
      v-for="(v, i) in getItems"
      :key="i"
      v-model="v.value"
      @focus="onFocus($event)"
      @blur="onBlur($event, i)"
    ></el-input>
  </div>
</template>

<script>
import { checkOtherVal } from '../public/index.js'
import { saveArr } from '../public/index.js'

export default {
  name: 'Blanks',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed:{
    getItems(){
      if(!this.rowData.items.length){
        this.rowData.items.push({value: '', optionId: "", rowId: "", colId: "", photos: null })
      }
      return this.rowData.items;
    }
  },
  data() {
    return {
      errorText: '',
      isError: false,
      oldInputVal: ''
    }
  },
  methods: {
    onBlur(e, i) {
      let fillContext = ''
      let res = ''
      if (this.rowData?.questionDetails?.issue?.fillContext) {
        // 4填空题
        fillContext = this.rowData.questionDetails.issue.fillContext[i]
        res = this.checkOtherVal(e.target.value, fillContext) // 校验
      } else {
        // 7 8
        // todo 校验待处理
        res = false
      }
      this.isError = res
      if (res) {
        this.rowData.items[i].value = this.rowData.items[i] ? this.oldInputVal : ''
      }
      this.saveArr()
    },
    // saveArr(){
    //   let ids = this.updateArr.indexOf(this.rowData)
    //   if(ids === -1){
    //     this.updateArr.push(this.rowData)
    //   }
    // },
    onFocus(e) {
      this.oldInputVal = e.target.value
    },
    // onBlur(e,item){
    //   let res = this.checkOtherVal(e.target.value,item);// 校验
    //   this.isError = res;
    //   if(res){
    //     this.rowData.items.find(i => i.optionId === item.id).value = item.content.text + '|' + this.oldInputVal
    //   }
    //   this.saveArr();
    // },
    checkOtherVal,
    saveArr
  }
}
</script>

<style lang="scss" scoped></style>
